import React from 'react';
import Video from 'react-responsive-video';
import TempoVideo from '../../video/AVP-HERO.mov';
import '../../styles/Hero.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBasketballBall, faGlassCheers, faSpa, faDumbbell, faClapperboard } from '@fortawesome/free-solid-svg-icons';


function HeroVid({ setCurrentIndex }) {

      // Smooth Scroll Function
            const scrollToSection = (index) => {
          // 1. Change the carousel slide first
          setCurrentIndex(index);

          // 2. Scroll to the section
          const element = document.getElementById('facilities-carousel');
          if (element) {
            const offset = 80;
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
              top: elementPosition - offset,
              behavior: 'smooth'
            });
          }
        };

  return (
    <>
        <div className='heropage-wrap' data-aos="fade">
            <div className='hero-vid'>
                {/**<Video mp4={vsclubvid} /> */}
                <Video mp4={TempoVideo} />

                {/**
                  <div className='member-btn'>
                    <a href="/membership"><button>BE A MEMBER NOW! <i></i> </button></a>
                  </div>
                */}

                  {/* <div className="head-label">
                    <p className='head-caption'>CREATING LIFESTYLE EXPERIENCE</p>
                  </div> */}

                   <div className='hero-nav-container'>
                      {/* Sports Item - Scrolls to Carousel and targets index 0 */}
                      <div className="hero-nav-item" onClick={() => scrollToSection(0)} style={{cursor: 'pointer'}}>
                        <div className="hero-nav-box">
                          <FontAwesomeIcon 
                            icon={faBasketballBall} 
                            className="nav-icon-styled" 
                            style={{ color: "#f58220" }} 
                          />
                          <span>Sports</span>
                        </div>
                      </div>

                      <div className="hero-nav-item" onClick={() => scrollToSection(1)} style={{cursor: 'pointer'}}>
                        <div className="hero-nav-box">
                          <FontAwesomeIcon 
                            icon={faDumbbell} 
                            className="nav-icon-styled" 
                            style={{ color: "#7f8c8d" }} 
                          />
                          <span>Fitness</span>
                        </div>
                      </div>

                      <div className="hero-nav-item" onClick={() => scrollToSection(2)} style={{cursor: 'pointer'}}>
                        <div className="hero-nav-box">
                          <FontAwesomeIcon 
                            icon={faSpa} 
                            className="nav-icon-styled" 
                            style={{ color: "#8fcbbc" }} 
                          />
                          <span>Wellness</span>
                        </div>

                      </div>

                      <div 
                        className="hero-nav-item" 
                        onClick={() => {
                          const el = document.getElementById('home-events');
                          if (el) {
                            const offset = 80; // The height of your navbar
                            const bodyRect = document.body.getBoundingClientRect().top;
                            const elementRect = el.getBoundingClientRect().top;
                            const elementPosition = elementRect - bodyRect;
                            const offsetPosition = elementPosition - offset;

                            window.scrollTo({
                              top: offsetPosition,
                              behavior: 'smooth'
                            });
                          }
                        }} 
                        style={{cursor: 'pointer'}}
                      >
                        <div className="hero-nav-box">
                          <FontAwesomeIcon 
                            icon={faGlassCheers} 
                            className="nav-icon-styled" 
                            style={{ color: "#4a90e2" }} 
                          />
                          <span>Events</span>
                        </div>
                      </div>


                      <a href="/cinema" className="hero-nav-item" style={{ textDecoration: 'none' }}>
                        <div className="hero-nav-box">
                          <FontAwesomeIcon icon={faClapperboard} className="nav-icon-styled" style={{ color: "#e74c3c" }} />
                          <span>Entertainment</span>
                        </div>
                      </a>

                      
                    </div>

                {/* <div className='heroDesc'>
                  <p data-aos="fade-up">
                      Our space offers you access to a multitude of sports facilities and state-of-the-art
                      fitness equipment to cater to your active lifestyle. Whether you want to spend a night bonding
                      with your family, relax in our water spa pools, play a game of tennis
                      or join studio classes, we’ve got you covered.
                  </p>
                </div> */}
            </div>
        </div>
    </>
  )
}

export default HeroVid